module.exports = new __parcel__URL__("or_image.110898ad.png").toString();